export default __webpack_public_path__ + "static/media/bloodyhack5.e1f24f2b.png";